<template>
    <el-drawer :modal="false" 
        title="Commission Settings"
        :visible.sync="drawer_hub_commission_setting"
        class="drawer-commission-settings"
        size="45%"
    >
        <b-container>
            <el-collapse accordion>
                <el-collapse-item name="1" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Direct Payout Settings</h3>
                    </div>
                    <HubDirectPayoutSettings/>
                </el-collapse-item>
                <el-collapse-item name="2" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Advisory Direct Payout Settings</h3>
                    </div>
                    <HubAdvisoryDirectPayoutSettings/>
                </el-collapse-item>
                <el-collapse-item name="3" class="my-3" v-if="$route.params.hub_team_id">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Team KPI Settings</h3>
                    </div>
                    <HubKpiSettings/>
                </el-collapse-item>
                <el-collapse-item name="4" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Token Rewards Settings</h3>
                    </div>
                    <TokenRewards/>
                </el-collapse-item>
                <el-collapse-item name="5" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Revenue Point Distribution Settings</h3>
                    </div>
                    <HubRevenueDistributionSettings/>
                </el-collapse-item>
            </el-collapse>
        </b-container>
    </el-drawer>
</template>
<script>
    import { Button, Drawer, Collapse, CollapseItem } from 'element-ui'
    import HubDirectPayoutSettings from '@/views/Commission/Hub/HubProfile/OffCanvasDetails/DrawerHubCommissionSettings/HubDirectPayoutSettings'
    import HubAdvisoryDirectPayoutSettings from '@/views/Commission/Hub/HubProfile/OffCanvasDetails/DrawerHubCommissionSettings/HubAdvisoryDirectPayoutSettings'
    import HubKpiSettings from '@/views/Commission/Hub/HubProfile/OffCanvasDetails/DrawerHubCommissionSettings/HubKpiSettings'
    import HubRevenueDistributionSettings from '@/views/Commission/Hub/HubProfile/OffCanvasDetails/DrawerHubCommissionSettings/HubRevenueDistributionSettings'
    import { mapActions,mapState } from 'pinia'
    import { useHubStore } from '@/stores/hubStore'
    import helperFunctionMixin from '@/assets/js/helperFunctionMixin'
    import TokenRewards from './TokenRewards.vue'

    export default {
        components: {
            HubDirectPayoutSettings,
            HubAdvisoryDirectPayoutSettings,
            HubKpiSettings,
            HubRevenueDistributionSettings,
            TokenRewards,
            [Button.name]: Button,
            [Drawer.name]: Drawer,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            TokenRewards
        },
        mixins: [
            helperFunctionMixin
        ],
        data() {
            return {
                drawer_hub_commission_setting: false,
                tables: [],
            };
        },
        computed: {
            ...mapState(useHubStore,['current_hub', 'current_team'])
        },
        async created() {
            if(this.$route.params.hub_id)
            {
                await this.getHub(this.$route.params.hub_id)
            }
            else if(this.$route.params.hub_team_id)
            {
                await this.getHubTeams(this.$route.params.hub_team_id)
            }

        },
        methods: {
            ...mapActions(useHubStore,['getHub', 'getHubTeams']),
            viewHubCommissionSettings() {
                this.drawer_hub_commission_setting = !this.drawer_hub_commission_setting;
            },
        }
    }
</script>